<template>
  <div class="newest">
    <div class="newest-play">
      <div class="newest-Location">
        <LatestNews></LatestNews>
      </div>
    </div>
  </div>
</template>

<script>
  import LatestNews from "@/common/components/LatestNews";
  export default {
    name: "newest",
    components: {LatestNews}
  }
</script>

<style scoped>
  .newest{
    width: 100%;
    height: 33px;
    margin-top: 35px;
  }

  .newest-play{
    width: 1320px;
    height: 30px;
    margin: 0 auto;
  }

  .newest-Location{
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/components/newest.vue